

/*
	Source: htdocs/wim/js/core/src/RadioPlayer.js
*/
(function($, wimbledonCore) {
/**
     *  RadioPlayer
     */
    function RadioPlayer() {
        var id = 'RadioPlayer';
        var logger = new eventsCore.util.Logger(id);

        var which_radio, which_radio_measure;
        var which_radio_state = {
            'station1': false,
            'station2': false,
            'station3': false
        };
        var court_radio_map = {
            A: 'station2',
            B: 'station3'
        };

        var radio_type = 'html5';
        var radio_playing = false;
        var fetchIntervalId;

        /**
        * AO 2017 Radio States
        *
        * 0 - radio is off air
        * 1 - radio is on air and not playing
        * 2 - radio is on air and playing
        **/
        var _status = {
            offair: 0,
            onair: 1,
            playing: 2
        };

        var activeChannelId = '';

        var _channelPaths = {
            'station1': 'http://ibm-wimbledon-radio-core.akacast.akamaistream.net/7/871/32059/v1/auth.akacast.akamaistream.net/ibm-wimbledon-radio-core.mp3',
            'station2': 'http://ibm-wimbledon-radio-centre.akacast.akamaistream.net/7/284/32059/v1/auth.akacast.akamaistream.net/ibm-wimbledon-radio-centre.mp3',
            'station3': 'http://ibm-wimbledon-radio-court1.akacast.akamaistream.net/7/261/32059/v1/auth.akacast.akamaistream.net/ibm-wimbledon-radio-court1.mp3'
        };

        var initRadio = function(type) {
            var selector = window;

            $(document).ready(function(){
                logger.info('init - document ready');
                logger.info('init - isIpad:%o', window.browser.isIPad);


                // Set which_radio var for setting styles
                if(radio_page == 'slamtracker'){
                    which_radio = $('#radioContentContainer');
                    which_radio_measure = 'Slamtracker';
                } else {
                    which_radio = $('#radioModule');
                    which_radio_measure = 'Site';
                }

                // Set click functions for buttons
                which_radio.find('.playbutton').click(function(){
                    var channelId = $(this).parent().attr('id');
                    if(!radio_playing) {
                        startStream(channelId);
                        window.measureApp(which_radio_measure,'radio','play');
                    } else if(radio_playing) {
                        if(activeChannelId === channelId) {
                            stopStream(channelId);
                            window.measureApp(which_radio_measure,'radio','stop');
                        } else {
                            startStream(channelId);
                            window.measureApp(which_radio_measure,'radio','play');
                        }
                    }
                    return false;
                });

                // Load the HTML5 audio components
                audioPlayer = document.getElementById('html5RadioPlayer');

                $('#radioPlayer').hide();
                $('#html5RadioPlayerContainer').show();

                radio_type = "html5";

                //console.log(audioPlayer);
                var request = radio_pollResult();
                fetchIntervalId = setInterval(function() {
                    radio_pollResult();
                }, 60000);

                // update radio status
                request.success(function() {
                    _.each(which_radio_state, function(state, station) {
                        if(state) {
                            if (radio_playing && activeChannelId === station) {
                                logger.info("radioStatus:channels: radio is playing %o!", station);
                                radioStatus(station, _status.playing);
                            } else {
                                logger.info("radioStatus:channels: radio is not playing %o!", station);
                                radioStatus(station, _status.onair);
                            }
                        } else{
                            // Radio is off air
                            radioStatus(station, _status.offair);
                        }
                    });
                });

                checkStatus();

                // auto-start selected stream if on air
                var stream = eventsCore.util.getUrlParam('stream');
                request.done(function(data) {
                    if(which_radio_state['station' + stream] === true) {
                        startStream('station' + stream);
                    }
                })

            });

        };

        var init = function() {
            var request = radio_pollResult();
            fetchIntervalId = setInterval(function() {
                radio_pollResult();
            }, 60000);
        }

        var checkChannel = function(courtId) {
            var stationId = court_radio_map[courtId];
            if(stationId) {
                if(which_radio_state[stationId]) {
                    return stationId.substring(7,8);
                }
                return false;
            }

            return false;
        }

        var destroy = function() {
            clearInterval(fetchIntervalId);
        }

        function radioStatus(channelId, status){
            logger.info('radioStatus - channels:%o, status: %o', channelId, status);

            var which_channel = which_radio.find('#' + channelId);

            switch(status){
                case _status.offair:
                    which_channel.addClass('offair');
                    which_channel.removeClass('onair playing');

                    if(radio_playing && activeChannelId === channelId){
                        stopStream();
                    }

                    break;
                case _status.onair:
                    which_channel.addClass('onair');
                    which_channel.removeClass('playing offair');
                    break;
                case _status.playing:
                    which_channel.addClass('playing onair');
                    which_channel.removeClass('offair');
                    break;
                default:
                    break;
            }
        }

        /****************************************************************
        ** Radio functions
        ****************************************************************/
        function playBackStarted(){
            flashLog("debug","playBackStarted");
            radio_playing = true;

            var which_channel = which_radio.find('#' + activeChannelId);
            which_channel.removeClass('loading');
            which_channel.addClass('playing');
        }

        function startStream(channel){
            // stop existing stream if one was playing
            if(radio_playing) {
                stopStream(activeChannelId);
            }

            var streamUrl = _channelPaths[channel];
            audioPlayer.src = streamUrl;

            audioPlayer.load();
            audioPlayer.play();
            activeChannelId = channel;
        }

        function stopStream(channel){
            audioPlayer.pause();

            var which_channel = which_radio.find('#' + activeChannelId);
            which_channel.removeClass('playing');

            radio_playing = false;
            activeChannelId = '';
        }

        function checkStatus() {
            $(audioPlayer).on('play', function(e) {
                logger.info('audio has started');
                radio_playing = true;

                var which_channel = which_radio.find('#' + activeChannelId);
                which_channel.addClass('playing');
            }).on('pause', function(e) {
                logger.info('audio has paused');
            });
        }

        /****************************************************************
        ** HTML5 Radio functions
        ****************************************************************/
        function radio_pollResult(data){
            var req = $.ajax({
                url: window.radioIndicatorsPath,
                dataType: 'json'
            });

            try{
                req.fail(function(jqXHR, textStatus, errorThrown){
                    //console.log("radio_pollResult: Error retrieving data");
                }).done(function(data){
                    var channels = data.radio;

                    for(var i = 0, l = channels.length; i < l; i++) {
                        channels[i].channelId = 'station' + (i + 1);
                        which_radio_state[channels[i].channelId] = channels[i].onAir;
                    }

                })
            } catch (e){
                //console.log('radio_pollResult ERROR - '+e);
            }

            return req;
        }

        return {
            init: init,
            initRadio: initRadio,
            check: checkChannel,
            destroy: destroy
        };
    };

    wimbledonCore.radioPlayer = new RadioPlayer();

}(jQuery, window.wimbledonCore));